import React from 'react'
import List from './List'
import { useCandidateOfferLetterById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const candidate = useCandidateOfferLetterById(id)
  return (
    <List candidate={candidate} />
  )
}

export default Body
